module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/bg-container-brown-adb7072ee7503a99eed53a2fa1941183.png";